import React from "react";
import { cn } from "./cn";

/**
 * Bun breadcrumbs: 12/450 stone trail, current page in strong text.
 * items: [{ label, onClick? | href? }] — the last item renders as current.
 * renderItem({ item, isCurrent, children }) can wrap or replace an entry.
 */
export default function Breadcrumbs({ items = [], className, renderItem }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={cn("flex items-center gap-[6px] font-instrument text-bun-meta font-book text-bun-stone", className)}
    >
      {items.map((item, i) => {
        const last = i === items.length - 1;
        const content = last ? (
          <span aria-current="page" className="text-bun-text font-strong">
            {item.label}
          </span>
        ) : item.href ? (
          <a href={item.href} className="inline-flex min-h-11 items-center sm:min-h-0 text-bun-stone no-underline hover:text-bun-blue">
            {item.label}
          </a>
        ) : (
          <button
            type="button"
            onClick={item.onClick}
            className="inline-flex min-h-11 items-center sm:min-h-0 bg-transparent border-0 p-0 cursor-pointer font-instrument text-bun-meta font-book text-bun-stone hover:text-bun-blue"
          >
            {item.label}
          </button>
        );
        return (
          <React.Fragment key={i}>
            {i > 0 && <span aria-hidden="true">&#8250;</span>}
            {renderItem ? renderItem({ item, isCurrent: last, children: content }) : content}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
